import { Backdrop, CircularProgress } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserDataContext } from "../Contexts/UserDataContext";

const AuthenticatedRoute = ({
  component: Component,
  redirectPath,
  ...rest
}) => {
  const { userData, verifyToken } = useContext(UserDataContext);
  const [loading, setLoading] = useState(true);

  console.log("authenticated route render");

  useEffect(() => {
    // if it is undetermined whether the user is logged in
    if (!Object.keys(userData).includes("loggedIn")) {
      verifyToken();
    }
  }, [userData, verifyToken]);

  useEffect(() => {
    // if it is determined whether the user is logged in
    if (loading && Object.keys(userData).includes("loggedIn")) {
      setLoading(false);
    }
  }, [userData, loading]);

  return (
    <>
      {loading ? (
        <Backdrop open>
          <CircularProgress size={120} />
        </Backdrop>
      ) : (
        <Route
          {...rest}
          component={() =>
            userData.loggedIn ? <Component /> : <Redirect to={redirectPath} />
          }
        />
      )}
    </>
  );
};

export default AuthenticatedRoute;
